import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityDescriptionChange } from '../../projectDetailsActivities.models';

export const DescriptionChangeActivity = ({ values }: IProjectActivity<IProjectActivityDescriptionChange>): ReactElement => {
  const { t } = useTranslator();
  return (
    <div>
      {t('activity_description_DescriptionChange')}
      <b>{values.description}</b>.
    </div>
  );
};
